import { history } from 'instantsearch.js/es/lib/routers'

const routerProxy = (indexName: string) => ({
  router: history({
    createURL ({ qsModule, location, routeState }) {
      const { origin, pathname, hash, href } = location
      const indexKeys = Object.keys(routeState)

      if (indexKeys.length > 0) {
        const query = routeState[indexName].query
          ? routeState[indexName].query
          : null

        delete routeState[indexName].query

        // create new state with compressed version
        const compressedUrl = {
          i1: {
            ...routeState[indexName]
          }
        }

        const queryString = qsModule.stringify(compressedUrl)

        if (query) {
          return `${origin}/search?term=${query}&searchTerm=${query}&searchType=default&index=${indexName}${
            queryString.length > 0 ? '&' : ''
          }${queryString}${hash}`
        }
        return href
      } else {
        return `${origin}${pathname}${hash}`
      }
    },
    parseURL ({ qsModule, location }) {
      const verifyGoogleParams = () => {
        if (
          location.href.includes('gad_source') ||
          location.href.includes('gclid')
        ) {
          return qsModule.parse(location.search.replaceAll('?', '&').slice(1))
        }

        return qsModule.parse(location.search.slice(1))
      }

      const parsed = verifyGoogleParams()

      let query = null

      // capture term if available
      if (parsed.term && parsed.index) {
        query = parsed.term
        if (query) {
          if (!parsed['i1']) {
            parsed['i1'] = {}
          }
          parsed['i1']['query'] = query
        }
      }
      // remove search Type and queries
      delete parsed.term
      delete parsed.searchTerm
      delete parsed.searchType

      // Check if can decompress
      if (parsed.index) {
        const finalObj = {}

        finalObj[parsed.index] = { ...parsed.i1 }

        delete parsed.index
        return finalObj
      }
      return parsed
    }
  })
})

export default routerProxy
